import classNames from "classnames";

import PropTypes from "prop-types"

const Modal = ({title, isOpen, close, children, closeButton=true}) => {

    return (
        <div className={classNames("modal", isOpen ? "" : "hidden")}>
            <div className="modal-dialog">
                <div className="modal-header">
                    {!!closeButton && <button className="close-button" onClick={() => close()}>&times;</button>}
                    <div className="modal-title">{title} </div>
                </div>
                <div className="modal-body">
                    {children}
                </div>
            </div>
        </div>
    )
}

Modal.propTypes = {
    title: PropTypes.string,
    isOpen: PropTypes.bool,
    close: PropTypes.func,
    children: PropTypes.node,
    __TYPE: PropTypes.string
}

Modal.defaultProps = {
    __TYPE: "MODAL"
}

export default Modal;